import { 
	SEND_PAYMENT_SUCCESS_MAIL 
} from '@/store/actions.type';
import axios from 'axios'
import legalagreementpostpayment from '@/components/legalagreementpostpayment.vue'


import moment from 'moment'
export default {
  components: {
		legalagreementpostpayment
	},
  data () {
      return {
        ispaymentinfopresent: true,
        legalAgreementContent:"",
        isEsignActive:false,
       	showEsign:false,
        esignRecord:null
      }
  },

  computed: {
	  paymentinfo() {
        localStorage.setItem("postPaymentReportGenerate",true);
        var paymentinfo = this.$store.state.home.paymentprocess;    
        if(paymentinfo.subType === undefined)
			this.ispaymentinfopresent = false;
        else {
            var userEmail = this.$store.state.authentication.user.email;
            var name = this.$store.state.authentication.user.name;
            var expiryDate = this.$store.state.home.paymentprocess.expiryDate;
            var paymentSuccessObj = {};
            paymentSuccessObj.userEmail = userEmail;
            paymentSuccessObj.expiryDate = moment(String(expiryDate)).format('MMM, DD YYYY');
            paymentSuccessObj.name = name.charAt(0).toUpperCase() + name.slice(1);
            paymentSuccessObj.reqId = paymentinfo.reqId;
            paymentSuccessObj.isBrokerUser = window.location.href.indexOf('/ar') > -1 ? true:false;
            this.$store.dispatch(SEND_PAYMENT_SUCCESS_MAIL , paymentSuccessObj);
		}
        
		return paymentinfo;
      },
      userData () {
        return this.$store.state.authentication.user;
      },
  },
  mounted() {
    this.checkEsignStatus();
  },
  methods:{
	  async fetchAgreement() {
      try {
        const response = await axios.get('https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/userlegalagreement/agreementtype.json', {
          params: {
            productCode: 'psi',
            agreementtype: 3,
          }
        });
        this.legalAgreementContent = response.data.data.description;
        this.isEsignActive = response.data.data.isEsign === 1;
      } catch (error) {
        this.$notify({
            group: 'allAlerts',
            title: '',
            type: 'error',
            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Error fetching agreement: ' + error.response?.data || error.message + '</span></div>'
        });
      }
    },

    async checkEsignStatus() {
			try {
			  const userId = localStorage.getItem("uid");
				const productType = "psi";
				const response = await axios.get("https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/user/isEsignDone.json", {
					params: { userId, productType }
				});

				const responseData = response?.data?.data;

				if (responseData?.success === false) {
					this.esignRecord = {
						id: responseData.id ?? null,
						UserId: responseData.UserId ?? null,
						product: responseData.product ?? null,
						transactionId: responseData.transactionId ?? null,
						pdflink: responseData.pdflink ?? null,
						createdDate: responseData.createdDate ?? null,
						updatedDate: responseData.updatedDate ?? null
					};
					this.fetchAgreement();
					this.showEsign = true;
				} else {
					this.showEsign = false;
					
				}
			} catch (error) {
        this.$notify({
            group: 'allAlerts',
            title: '',
            type: 'error',
            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">Error while checking e-sign status:'+ error +'</span></div>'
        });
			}
		}
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/paymentsuccess.js